<router-outlet></router-outlet>

<app-cookie-banner></app-cookie-banner>
<app-snackbar-container style="pointer-events: none;"></app-snackbar-container>
